import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  return isAuthenticated ? <Outlet /> : <Navigate to="/signin" replace />;
}

export function RoleRoute({ role }) {
  const { isAuthenticated, role: userRole, loading } = useAuth();
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/signin" replace />;
  return userRole === role ? <Outlet /> : <Navigate to="/" replace />;
}

export function GuestRoute() {
  const { isAuthenticated, role, loading } = useAuth();
  if (loading) return null;
  if (!isAuthenticated) return <Outlet />;
  const redirectPath =
    role === "admin"
      ? "/dashboard"
      : role === "provider"
      ? "/provider"
      : role === "channel_partner"
      ? "/channelpartner"
      : role === "promoter"
      ? "/promoter"
      : "/";
  return <Navigate to={redirectPath} replace />;
}
